import * as base64 from '@/lib/base64';

export function generateCompanyCrossTagReportsV2(vendor, records) {
  const repGrps = [];
  const grpMap = {};
  // Group records by tagId.
  for (let i = 0, len = records.length; i < len; i++) {
    const record = records[i];
    if (!record) {
      continue;
    }
    const cost = record[vendor];
    if (!cost) {
      continue;
    }

    const grpKey = cost.tagId ? cost.tagId : `nontag${cost.account}`;
    let grp = grpMap[grpKey];
    if (!grp) {
      const dt = new Date(cost.date);
      grp = {
        customer_id: '',
        month: `${dt.getFullYear()}-${dt.getMonth() + 1}`,
        services: [cost],
      };
      if (cost.tagId) {
        const decodedTagId = base64.decode(cost.tagId);
        const tagObj = JSON.parse(decodedTagId);
        const kv = tagObj.tags[0];

        grp.tag_key = kv.key;
        grp.tag_value = kv.value;
        grp.customer_name = `${kv.key}: ${kv.value} (${cost.account})`;
      } else {
        grp.tag_key = 'nontag';
        grp.tag_value = '';
        grp.customer_name = `Non tag (${cost.account})`;
      }
    } else {
      grp.services.push(cost);
    }
    grpMap[grpKey] = grp;
  }

  // Group services of each tag group.
  if (Object.keys(grpMap).length === 0) {
    return [];
  }
  for (const gkey in grpMap) {
    const grp = grpMap[gkey];
    const svcMap = {};
    const svcs = [];

    // Group services by service code and sum up the total cost.
    for (let i = 0, len = grp.services.length; i < len; i++) {
      const svc = grp.services[i];
      if (!svc || !svc.cost) {
        continue;
      }
      const usage = Math.round(svc.usage * 100000) / 100000;
      const rep = {
        availability_zone: svc.zone,
        description: svc.description,
        instance_type: svc.instanceType,
        operation: svc.operation,
        region: svc.region,
        usage_type: svc.usageType,
        usage_quantity: usage,
        cost: svc.cost,
        resource_id: svc.resourceId,
      };
      const code = svc.serviceCode ? svc.serviceCode : svc.productCode;
      let newSvc = svcMap[code];
      if (!newSvc) {
        newSvc = {
          service: code,
          total: svc.cost,
          report: [rep],
        };
        svcMap[code] = newSvc;
      } else {
        newSvc.total += svc.cost;
        newSvc.report.push(rep);
      }
    }

    // Convert report map to array and set it to service's report list.
    for (const skey in svcMap) {
      const svc = svcMap[skey];
      svc.report.sort((a, b) => {
        const left =
          '' + (a.instance_type ? '_' + a.instance_type : '') + a.usage_type + a.operation;
        const right =
          '' + (b.instance_type ? '_' + b.instance_type : '') + b.usage_type + b.operation;
        return left.localeCompare(right);
      });
      svcs.push(svc);
    }

    grp.services = svcs;
    repGrps.push(grp);
  }

  // Sort report groups.
  repGrps.sort((a, b) => {
    if (a.tag_key === 'nontag') {
      return 1;
    }
    if (b.tag_key === 'nontag') {
      return -1;
    }
    const left = '' + a.tag_key + a.tag_value;
    const right = '' + b.tag_key + b.tag_value;
    return left.localeCompare(right);
  });

  return repGrps;
}

export function returnServices(allData) {
  let resultMap = {};
  let results = [];
  for (const item of allData) {
    for (const svc of item.services) {
      let total = 0;
      let filteredReports = [];
      if (resultMap[svc.service]) {
        total = resultMap[svc.service].total; // initial total (sum up service total from other account)
      }
      for (const rep of svc.report) {
        total += rep.cost;
        rep.customer_name = item.customer_name;
        filteredReports.push(rep);
      }
      if (filteredReports.length === 0) {
        continue;
      }
      if (resultMap[svc.service]) {
        resultMap[svc.service].report.push(...filteredReports);
      } else {
        resultMap[svc.service] = {
          report: filteredReports,
          service: svc.service,
        };
      }
      resultMap[svc.service].total = total;
    }
  }
  let services = [];
  for (const svc in resultMap) {
    services.push(resultMap[svc]);
  }
  results = services;
  return results;
}
